import { render, staticRenderFns } from "./genericdeletemodal.vue?vue&type=template&id=5752cfbc&scoped=true"
import script from "./genericdeletemodal.vue?vue&type=script&lang=js"
export * from "./genericdeletemodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752cfbc",
  null
  
)

export default component.exports